export interface ISummaryCounterStyles {
  background: string;
  iconClass: string;
}
